module.exports = "/fonts/FiraSans-Medium.ttf";